export default {
  currentContract: {
    ContractNo: '',
    NearestPaymentDate: null,
    NearestPaymentAmount: '',
    OriginAmount: '',
    InterestAmount: '',
    LateFee: '',
    NumDayOverdue: '',
    ResidualAmount: '',
    PaymentDueDate: null,
    TotalPaymentAmount: '',
    Car: {
      CarManufacturer: '',
      Brand: '',
      YearModel: '',
      CarTypeName: '',
      ContractNo: '',
      PlateNo: ''
    },
    PayooResult: {
      amount: 0,
      checksum: '',
      customerCode: '',
      desc: null,
      link: '',
      pass: '',
      pnc: '',
      txid: ''
    }
  }
}
